import MenuComponent from '@/components/MenuComponent'
import ActualitesComponent from '@/components/ActualitesComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  props: ['editedCarte'],
  data () {
    return {
      loading: false,
      localEditedCarte: this.editedCarte
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    ActualitesComponent
  },
  methods: {
    getCivility (civility) {
      if (civility === '1') {
        return 'M. '
      }
      if (civility === '3') {
        return 'Melle '
      }
      if (civility === '2') {
        return 'Mme '
      }
    },
    getRetraitLabel (retrait) {
      switch (retrait) {
        case 'O': // oui
          return 'oui'
        case 'N': // non
          return 'non'
        default:
          return null
      }
    },
    getCompteReglementLabel (compteReglement) {
      switch (compteReglement) {
        case 'E': // Entreprise
          return 'Entreprise'
        case 'P': // Porteur
          return 'Porteur'
        default:
          return '-'
      }
    },
    getEtatCarteLabel (carte) {
      var moment = require('moment')
      this.dateDeValidite = carte.dateValidite
      this.dateCloture = carte.closeDate
      if (this.dateDeValidite && this.dateCloture) {
        this.dateValiditeFormatee = moment(this.dateDeValidite, 'YYYYMM').add(1, 'M').format('YYYY-MM-DD')
        this.dateClotureFormatee = moment(this.dateCloture).format('YYYY-MM-DD')
        if (this.dateValiditeFormatee >= moment().format('YYYY-MM-DD') && this.dateClotureFormatee === '9999-12-31') {
          return 'active'
        }
      }
      return 'inactive'
    },
    getDateValidite (dateValidite) {
      if (dateValidite) {
        var moment = require('moment')
        return moment(dateValidite, 'YYYYMM').format('MM/YYYY')
      }
      return null
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Fiche détaillée'
    this.$store.state.filArianeMiddlePage = 'Parc de cartes'
    this.$store.state.filArianeMiddleRouterLink = 'entreprise/gestionnaireparcdecartes'
  },
  mounted () {
    if (this.$store.state.user.user.selectedEntreprise && this.editedCarte) {
      this.$store.dispatch('entreprise/putEditedCardInStore', this.editedCarte)
    }
    if (!this.editedCarte && this.$store.state.entreprise.editedCarte) {
      this.localEditedCarte = this.$store.state.entreprise.editedCarte
    }
  }
}
